import React from "react";
/*Loader */
import FadeIn from "react-fade-in";

/*animation*/
import loaderGif from "../animations/loader.gif";

export default function Loader(props) {
  return (
    <FadeIn>
      <div className="d-flex justify-content-center align-items-center">
        <img
          src={loaderGif}
          height={props.height}
          width={props.width}
          alt="Loading..."
        />
      </div>
    </FadeIn>
  );
}
